import { useInfiniteQuery } from '@tanstack/react-query';
import apiClient from 'services/apiClient';

export const PROFILE_MEDIA_PER_PAGE = 10;

export const profileConversationKeys = {
  media: (parent, child) => ['profile-conversation', 'media', parent, child],
  urls: (parent, child) => ['profile-conversation', 'urls', parent, child],
};

const fetchProfilePage = async ({ api, parent, child, type, page }) => {
  const response = await apiClient.get(`${api}reports-media/files/${parent}/${child}`, {
    params: {
      type,
      page,
      per_page: PROFILE_MEDIA_PER_PAGE,
    },
  });

  if (response.status !== 200) {
    throw new Error(`Failed to fetch profile ${type}`);
  }

  return response.data;
};

const profileInfiniteOptions = ({ api, parent, child, type, enabled }) => ({
  queryKey: type === 'media'
    ? profileConversationKeys.media(parent, child)
    : profileConversationKeys.urls(parent, child),
  queryFn: ({ pageParam = 1 }) => fetchProfilePage({
    api,
    parent,
    child,
    type,
    page: pageParam,
  }),
  initialPageParam: 1,
  getNextPageParam: (lastPage) => (
    lastPage?.has_more ? (lastPage.current_page || 1) + 1 : undefined
  ),
  enabled: Boolean(enabled && api && parent && child),
  staleTime: 5 * 60 * 1000,
  gcTime: 15 * 60 * 1000,
});

export const useProfileMedia = ({ api, parent, child, enabled = false }) => useInfiniteQuery(
  profileInfiniteOptions({ api, parent, child, type: 'media', enabled })
);

export const useProfileUrls = ({ api, parent, child, enabled = false }) => useInfiniteQuery(
  profileInfiniteOptions({ api, parent, child, type: 'urls', enabled })
);

export const flattenProfilePages = (data) => (
  data?.pages?.flatMap((page) => page?.data || []) ?? []
);

export const profileTotalFromPages = (data) => (
  data?.pages?.[0]?.total ?? 0
);
